import { Box, Button, HStack, Image, useToast } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import { MdUpload } from 'react-icons/md';
import { translate } from '../../../i18n';
import { useUploadLocationImage } from '../hooks/useUploadLocationImage';

type Props = { locationId: string; imageUrl?: string; };

const LocationImageUploader = ({ locationId, imageUrl }: Props) => {
    const toast = useToast();
    const { mutateAsync: uploadFile, isLoading: isUploading } = useUploadLocationImage(locationId, () => {
        toast({ title: translate('locations.location_edited_successfully'), status: 'success', duration: 3000, position: 'top-right' });
    });
    const [preview, setPreview] = useState<string | null>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        if (selectedFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result as string);
            };
            reader.readAsDataURL(selectedFile);
            uploadFile(selectedFile).catch(() => {
                toast({ title: translate('common.error'), status: 'error', duration: 3000, position: 'top-right' });
                setPreview(null);
            });
        }
    };

    const displayUrl = preview || imageUrl;

    return (
        <Box textAlign="center">
            {displayUrl && (
                <Image
                    src={displayUrl}
                    alt="Location"
                    borderRadius="xl"
                    objectFit="cover"
                    maxH="200px"
                    w="100%"
                    my={4}
                />
            )}
            <HStack justify="center" spacing={4}>
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: 'none' }}
                />
                <Button
                    isLoading={isUploading}
                    onClick={() => inputRef.current?.click()}
                    colorScheme="brand"
                    leftIcon={<MdUpload />}
                >
                    {translate('upload_image')}
                </Button>
            </HStack>
        </Box>
    );
};

export default LocationImageUploader;
